import React, { useState} from 'react';
import './OperationsTableComponent.css';
import { Table, TableHead, TableRow, TableHeaderCell, TableBody, TableCell, Dropdown, Button, DropdownItem } from "@tremor/react";
import { OrderSources, ShortOrder } from '../interfaces/OrderInterfaces'
import axios from 'axios';
import { useCookies } from 'react-cookie';
import { Link } from "react-router-dom";
import { meliSubStatusTranslate, shopeeLogisticStatusTranslate, statusChannelTranslate } from '../utils/translates'
import { convertDate, convertDateBr } from '../utils/convertDate';
import { ArrowDownRightIcon, CheckIcon } from '@heroicons/react/24/outline';

function OperationsTableComponent(
  {selectedOrders}:{selectedOrders:ShortOrder[]}
  ) {

    const [cookies] = useCookies(['mazelog-user']);
    const token = cookies['mazelog-user']?.token_data?.access_token;
    const oauth = "Bearer " + token;
    const baseURL = process.env.REACT_APP_MAZELOG_SYSTEM_BASE_URL;
    const userProfile = cookies['mazelog-user']?.user_data?.user_profile;
    const isTransporter = userProfile === "TRANSPORTER" || userProfile === "TRANSPORTER_COLLECTER"
    const isClient = userProfile === "CLIENT"
    const orgId = cookies["mazelog-user"]?.organization_data?.id_org;

    const statusTranslate: { [key: string]: string } = {
      "created": "Criado",
      "transporter_allocated": "Transportador alocado",
      "collected": "Coletado",
      "received": "Recebido",
      "en_route": "Em rota",
      "delivered": "Entregue",
      "cancelled": "Cancelado",
      "handling": "Em tratativa",
      "awaiting_return": "Aguard. devolução",
      "awaiting_transfer": "Aguard. transferência",
      "return_route": "Rota devolução",
      "returned": "Devolvido",
      "collected_not_received": "Coletados Não Receb.",
      "cancelled_after_received": "Canc. após Receb.",
      "returned_area_not_serviced": "Devolvido - Área não atendida",
      "new_driver_allocated": "Novo entregador alocado"
    }

  const [selectedStatus, setSelectedStatus] = useState<string>('');

  const changeOrderStatus = (orderId:string) => {
    axios.put(`${baseURL}/order/${orderId}/status`,
    {status:
      selectedStatus,
      observation:'N/A',
      collecter:{
        name:'Entregador',document:'00000000000'
      }
    },
    {headers:
      {'accept': 'application/json',
      'Content-Type': 'application/json',
      "Authorization": oauth}
    })
      .then((res)=>{
      console.log(res);
      })
      .catch((err)=>{
      console.log(err);
      alert('Pedido já possui esse status associado')
    })
  }

  const convertDate = (date:Date) => {
    let newDate = new Date(date);
    newDate.setHours(newDate.getHours() - 3);
    let newDateStr = newDate.toLocaleString('en-GB').substring(0, 10);
    return newDateStr
  }

  const truncateString = (text:string, maxLength: number):string => {
    if (text.length <= maxLength) {
      return text
    } else {
      return text.substring(0, maxLength) + '...'
    }
  }

  return (
    <main className="Page">
        <Table className='TableCls'>
          <TableHead>
              <TableRow>
                  <TableHeaderCell>ID do pedido</TableHeaderCell>
                  <TableHeaderCell className="text-left">Número da nota</TableHeaderCell>
                  <TableHeaderCell className="text-left">Canal</TableHeaderCell>
                  <TableHeaderCell className="text-left">Data de criação</TableHeaderCell>
                  <TableHeaderCell className="text-left">Data de atualização</TableHeaderCell>
                  <TableHeaderCell className="text-left">Status MZO</TableHeaderCell>
                  <TableHeaderCell className="text-left">Status Canal</TableHeaderCell>
                  <TableHeaderCell className="text-left">Sub Status Canal</TableHeaderCell>
                  <TableHeaderCell className="text-left">Remetente</TableHeaderCell>
                  <TableHeaderCell className="text-left">Destinatário</TableHeaderCell>
                  <TableHeaderCell className="text-left">CEP Dest</TableHeaderCell>
                  {(!isTransporter && !isClient) && (
                    <TableHeaderCell className="text-left">Transportador</TableHeaderCell>
                  )}
              </TableRow>
          </TableHead>

          <TableBody>
            {
              selectedOrders
                  .reduce<ShortOrder[]>((uniqueOrders, order) => {
                    const seenPackIds = new Set(uniqueOrders.map(o => o.packId));
                    
                    const seenReceiptNumbers = new Set(uniqueOrders.map(o => o.receiptNumber));

                    if (order.packId && seenPackIds.has(order.packId)) {
                      return uniqueOrders;
                    }

                    if (order.receiptNumber && seenReceiptNumbers.has(order.receiptNumber)) {
                      return uniqueOrders;
                    }

                    return [...uniqueOrders, order];
                  }, [])
                  .map((order) => {
                    let statusChannel = "-"
                    let subStatusChannel = "-"
                    let creationDate = convertDate(order.creationDate)

                    if (order.source === OrderSources.MERCADO_LIVRE) {
                      statusChannel = statusChannelTranslate[order.meliLastStatus?.status ?? ""]
                      subStatusChannel =  meliSubStatusTranslate[order.meliLastStatus?.substatus ?? ""]
                    }
                    else if (order.source === OrderSources.SHOPEE) {
                      const latest = [...(order.shopee_data_status?.response.tracking_info || [])].sort((a, b) => b.update_time - a.update_time)[0];
                      subStatusChannel = statusChannelTranslate[latest?.logistics_status ?? ""];
                      statusChannel  = shopeeLogisticStatusTranslate[order.shopee_data_status?.response.logistics_status ?? ""]
                      creationDate = convertDateBr(order.creationDate.toString())
                    }

                    return (
                      <TableRow key={ order.orderNumber }>
                        <TableCell className="TableField">
                          <Link to={`/order/${order.orderNumber}`}>
                            <u>{ order.orderNumber }</u>
                          </Link>
                        </TableCell>
                        <TableCell
                          className="TableField max-w-[250px] whitespace-normal truncate"
                          title={order.packId ?? order.receiptNumber}
                        >
                          {order.packId ?? order.receiptNumber}
                        </TableCell>
                        <TableCell className="TableField">{ order.source }</TableCell>
                        <TableCell className="TableField text-center">{ creationDate }</TableCell>
                        <TableCell className="TableField text-center">{ convertDate(order.lastStatusDate) }</TableCell>
                        <TableCell className="TableField">{ order.status !== 'created' ? (
                            <Dropdown
                              className='DropTrans'
                              defaultValue={order.status}
                              onValueChange={(value) => setSelectedStatus(value)}
                          >
                              <DropdownItem className='DropTransOption' value="collected" text="Coletado" />
                              <DropdownItem className='DropTransOption' value="received" text="Recebido" />
                              <DropdownItem className='DropTransOption' value="en_route" text="Em rota" />
                              <DropdownItem className='DropTransOption' value="delivered" text="Entregue" />
                              <DropdownItem className='DropTransOption' value="cancelled" text="Cancelado" />
                              <DropdownItem className='DropTransOption' value="handling" text="Em tratativa" />
                              <DropdownItem className='DropTransOption' value="awaiting_return" text="Aguard. devolução" />
                              <DropdownItem className='DropTransOption' value="awaiting_transfer" text="Aguard. transferência" />
                              <DropdownItem className='DropTransOption' value="return_route" text="Rota devolução" />
                              <DropdownItem className='DropTransOption' value="returned" text="Devolvido" />
                              <DropdownItem className='DropTransOption' value="collected_not_received" text="Coletados Não Receb." />
                              <DropdownItem className='DropTransOption' value="cancelled_after_received" text="Canc. após Receb." />
                              <DropdownItem className='DropTransOption' value="returned_area_not_serviced" text="Devolvido - Área não atendida" />
                              <DropdownItem className='DropTransOption' value="new_driver_allocated" text="Novo entregador alocado" />
                          </Dropdown> ): (
                            order.status
                          )}
                        </TableCell>
                        <TableCell className="TableField">{ statusChannel }</TableCell>
                        <TableCell className="TableField">{ subStatusChannel }</TableCell>
                        <TableCell className="TableField" title={order.sender}>{ truncateString(order.sender, 20) }</TableCell>
                        <TableCell className="TableField" title={order.receiver}>{ truncateString(order.receiver, 25) }</TableCell>
                        <TableCell className="TableField">{ order.receiverZIP }</TableCell>
                        {(!isTransporter && !isClient) && (
                          <TableCell className="TableField">{ order.transporter }</TableCell>
                        )}
                        <TableCell>
                          <Button onClick={() => changeOrderStatus(order.orderNumber)} icon={CheckIcon} className='OpenOrderBtn' />
                        </TableCell>
                      </TableRow>
                    )
                  }
                  ) 
            }
          </TableBody>
        </Table>
              {/* <Table className='TableCls'>
                <TableHead>
                    <TableRow>
                        <TableHeaderCell>ID do pedido</TableHeaderCell>
                        <TableHeaderCell className="text-left">Número da nota</TableHeaderCell>
                        <TableHeaderCell className="text-left">Data criação</TableHeaderCell>
                        <TableHeaderCell className="text-left">Status</TableHeaderCell>
                        <TableHeaderCell className="text-left">Remetente</TableHeaderCell>
                        <TableHeaderCell className="text-left">Destinatário</TableHeaderCell>
                        <TableHeaderCell className="text-left">CEP Dest</TableHeaderCell>
                        <TableHeaderCell className="text-left">Transportador</TableHeaderCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    { selectedOrders
                        .map((order) => (
                            <TableRow key={ order.orderNumber }>
                              <TableCell className="TableField">{ order.orderNumber }</TableCell>
                              <TableCell className="TableField">{ order.receiptNumber }</TableCell>
                              <TableCell className="TableField">{ convertDate(order.creationDate) }</TableCell>
                              <TableCell className="TableField">{ order.status !== 'created' ? (
                                <Dropdown
                                  className='DropTrans'
                                  defaultValue={order.status}
                                  onValueChange={(value) => setSelectedStatus(value)}
                              >
                                  <DropdownItem className='DropTransOption' value="collected" text="Coletado" />
                                  <DropdownItem className='DropTransOption' value="received" text="Recebido" />
                                  <DropdownItem className='DropTransOption' value="en_route" text="Em rota" />
                                  <DropdownItem className='DropTransOption' value="delivered" text="Entregue" />
                                  <DropdownItem className='DropTransOption' value="cancelled" text="Cancelado" />
                                  <DropdownItem className='DropTransOption' value="handling" text="Em tratativa" />
                                  <DropdownItem className='DropTransOption' value="awaiting_return" text="Aguard. devolução" />
                                  <DropdownItem className='DropTransOption' value="awaiting_transfer" text="Aguard. transferência" />
                                  <DropdownItem className='DropTransOption' value="return_route" text="Rota devolução" />
                                  <DropdownItem className='DropTransOption' value="returned" text="Devolvido" />
                                  <DropdownItem className='DropTransOption' value="collected_not_received" text="Coletados Não Receb." />
                                  <DropdownItem className='DropTransOption' value="cancelled_after_received" text="Canc. após Receb." />
                                  <DropdownItem className='DropTransOption' value="returned_area_not_serviced" text="Devolvido - Área não atendida" />
                                  <DropdownItem className='DropTransOption' value="new_driver_allocated" text="Novo entregador alocado" />
                              </Dropdown> ): (
                                statusTranslate[order.status]
                              )}</TableCell>
                              <TableCell className="TableField">{ truncateString(order.sender, 10) }</TableCell>
                              <TableCell className="TableField">{ truncateString(order.receiver, 25) }</TableCell>
                              <TableCell className="TableField">{ order.receiverZIP }</TableCell>
                              <TableCell className="TableField">{ order.transporter }</TableCell>
                              <Button onClick={() => changeOrderStatus(order.orderNumber)} className='OpenOrderBtn' />
                            </TableRow>
                        )) }
                </TableBody>
            </Table> */}
  </main>
  );
}

export default OperationsTableComponent;